<template>
  <v-card max-width="390px" width="100%" height="100%">
    <v-card-text class="pa-8">
      <v-row>
        <v-col cols="12" class="pb-10">
          <v-row justify="center">
            <div>
              <v-img v-if="isClickable"
                     @click="$router.push(`/${service.button.path}#${service.id}`)"
                     :src="require(`../assets/icons/${service.img}.png`)"
                     contain height="83px" width="86px" :alt="service.title"
                     style="cursor: pointer;"/>
              <v-img v-else
                     :src="require(`../assets/icons/${service.img}.png`)"
                     contain height="83px" width="86px"
                     :alt="$t(`${service.title}`)"/>
            </div>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-center">
          <div style="min-height: 66px;">
            <p class="font-weight-medium primary--text text--darken-3" :class="$vuetify.breakpoint.smAndDown ? 'subtitle-1 ' : 'title'">
              {{ $t(`${service.title}`) }}
            </p>
          </div>
          <div v-if="showDesc" v-html="$t(`${service.desc}`)" style="min-height: 116px;"></div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="service.button.text">
      <v-col  cols="12" class="text-center">
        <v-btn v-if="service.button.local"
               color="primary"
               @click="$router.push({name: service.button.path})"
               rounded class="px-3" min-width="134px">
          {{ $t(`${service.button.text}`) }}
        </v-btn>
        <v-btn v-else-if="service.button.external"
               color="primary"
               :href="`${service.button.path}`"
               target="_blank"
               rounded class="px-3" min-width="134px">
          {{ $t(`${service.button.text}`) }}
        </v-btn>
        <v-btn v-else
               color="primary"
               :href="`${publicPath}${service.button.path}`"
               target="_blank"
               rounded class="px-3" min-width="134px">
          {{ $t(`${service.button.text}`) }}
        </v-btn>
      </v-col>
      <!--<v-col  cols="12" class="text-center" v-else>
        <p class="body-2">
          {{ $t('proudBox.qualityAndEnvironmentalPolicy') }}
        </p>
        <v-btn v-if="service.button.local"
               color="primary"
               @click="$router.push({name: service.button.path})"
               rounded class="px-3" min-width="134px">
          {{ $t(`${service.button.text}`) }}
        </v-btn>
        <v-btn v-else-if="service.button.external"
               color="primary"
               :href="`${service.button.path}`"
               target="_blank"
               rounded class="px-3" min-width="134px">
          {{ $t(`${service.button.text}`) }}
        </v-btn>
        <v-btn v-else
               color="primary"
               :href="`${publicPath}${service.button.path}`"
               target="_blank"
               rounded class="px-3" min-width="134px">
          {{ $t(`${service.button.text}`) }}
        </v-btn>
        <v-divider class="my-5"></v-divider>
        <p class="body-2">
          {{ $t('proudBox.informationSecurityPolicy') }}
        </p>
        <v-btn color="primary"
               :href="`${publicPath}${service.button2.path}`"
               target="_blank"
               rounded class="px-3" min-width="134px">
          {{ $t(`${service.button2.text}`) }}
        </v-btn>
      </v-col>-->
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'serviceBox',
  props: {
    showDesc: Boolean,
    showButton: Boolean,
    isClickable: {
      type: Boolean,
      default: false,
    },
    service: Object,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    clickFunction() {
      if (this.service.button.path === 'services') {
        this.$router.push('/services');
      } else if (this.service.button.path) {
      }
    },
  },
};
</script>

<style scoped>

</style>
